//Import required modules
import React from 'react';
import PropTypes from 'prop-types'
import { updatePalette , copyColorToClipboard } from '../../store/actions';

const ColorCircle = ({id, cx, cy, color, selected}, {store}) =>
{
    let userWindow = store.getState().userWindow;
    let theme = store.getState().theme
    let strokeColor = theme === 'dark'?userWindow.darkColor:userWindow.lightColor;
    return (
    <circle className={theme}
        cx={cx} 
        cy={cy} 
        r={selected?userWindow.radiusSelected:userWindow.radius} 
        fill={color}
        strokeWidth={selected?'2px':'0px'}
        stroke={strokeColor}
        onClick={(event) => 
            {
                store.dispatch(updatePalette(id, color, selected, userWindow))
                store.dispatch(copyColorToClipboard(color))

                //Change the color clip position to the position where user clicked
                // var theThing = document.querySelector("#colorClipDiv");
                // theThing.classList.add('colorClipClicked');
                // theThing.classList.remove('colorClipClicked');
                // theThing.style.left = event.clientX + "px";
                // theThing.style.top = event.clientY + "px";
            }
        }>            
    </circle>
    )
}

ColorCircle.contextTypes = {
    store: PropTypes.object
}

export default ColorCircle;

